import React from "react"
import { Tooltip } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faXmark } from "@fortawesome/free-solid-svg-icons"

interface BuilderVariableChipProps {
  /** Full Data(Q) path, e.g. "Gender" or "Age Coded//18-24" */
  variable: string
  onRemove: (variable: string) => void
}

/**
 * Removable chip that displays a variable's leaf label and reveals the full
 * Data(Q) path on hover. Used inside row/column drop zones.
 */
const BuilderVariableChip: React.FC<BuilderVariableChipProps> = ({
  variable,
  onRemove,
}) => {
  const segments = variable.split("//")
  const leaf = segments[segments.length - 1]
  const showPath = segments.length > 1

  return (
    <Tooltip
      title={showPath ? <span className="qc-mono">{variable}</span> : undefined}
      placement="top"
      mouseEnterDelay={0.4}
    >
      <span className="qc-chip" role="listitem">
        <span className="qc-chip__label qc-mono">{leaf}</span>
        <button
          type="button"
          className="qc-chip__remove"
          aria-label={`Remove ${leaf}`}
          onClick={(e) => {
            e.stopPropagation()
            onRemove(variable)
          }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </span>
    </Tooltip>
  )
}

export default BuilderVariableChip
